import React from "react";
import LoadingSpinner from "../Utils/Spinner";
import {Columns, Heading, Table} from "react-bulma-components";


export default function RentalFigures({rentalsData, rentalsLoaded, totalIncome}){
    const colour = () => {
        if(totalIncome > 0){
            return "table-highlight-green-black-text"
        }
        else if(totalIncome < 0){
            return "table-highlight-red"
        }
        return "table-highlight-orange"
    }


    if(!rentalsLoaded){
        return <LoadingSpinner/>
    }


    return (
        <div>
            <Heading>Rentals</Heading>
            <Columns>
                <Columns.Column>
                    <Table bordered>
                        <thead>
                            <tr>
                                <th>Total Long Term Income</th>
                                <th>Total Short Term Income</th>
                                <th>Total Income</th>
                            </tr>
                            <tr>
                                <td>{rentalsData.total_long_term_income}</td>
                                <td>{rentalsData.total_short_term_income}</td>
                                <td className={colour()}>{totalIncome}</td>
                            </tr>
                        </thead>
                    </Table>
                </Columns.Column>
            </Columns>
        </div>
    )



}